<div class="py-4 text-center" *ngIf="hasPlannedJump()">
  <button type="button" class="btn btn-primary btn-lg" (click)="doJump()">
    Open {{getSelectionDescription()}}
  </button>
</div>

<app-modal-v2 #occModal>
  <div class="modal-content text-dark">
    <div class="modal-header">
      <h5 class="modal-title">New Teacher&rsquo;s eBooks available</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p class="font-weight-bold">You are about to open the new OCC Teacher's eBook for Callan English Stage {{getPlannedStageNumber()}}.</p>
      <p>The OCC eBooks are specially designed for online lessons and include six additional charts.
        If you are new to this content, you can familiarize yourself with it first in the Callan App
        or the <a href="https://mycallan.com" target="_blank" rel="noopener">mycallan.com</a> eBook reader.</p>
      <div class="text-right">
        <button type="button" class="btn btn-secondary mr-1" (click)="openStandard()">Use the original eBook for now.</button>
        <button type="button" class="btn btn-primary" (click)="continueWithOcc()">Use the new OCC eBook.</button>
      </div>
      <div class="form-check d-flex align-items-center pl-0 mt-3">
        <input #alwaysOccCheckbox class="form-check-input position-static mt-0 ml-0 mr-2" type="checkbox" id="alwaysOccCheckbox"
               [checked]="alwaysOcc" (change)="alwaysOcc = alwaysOccCheckbox.checked">
        <label class="form-check-label" for="alwaysOccCheckbox">
          Always open the new OCC eBooks in the future and don&rsquo;t show this message again.
        </label>
      </div>
    </div>
  </div>
</app-modal-v2>
